import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import CmtCardHeader from '@coremat/CmtCard/CmtCardHeader';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

const UsefulLinkCard = ({ usefulLink }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const formattedDescription = usefulLink.description?.split('\n').join('<br />');
  const formattedWebsiteUrl = usefulLink.websiteUrl
    ? usefulLink.websiteUrl.startsWith('http')
      ? usefulLink.websiteUrl
      : `https://${usefulLink.websiteUrl}`
    : '';

  return (
    <CmtCard sx={{ height: '100%', padding: 0 }}>
      <CmtCardHeader
        separator={{
          color: theme.palette.borderColor.dark,
        }}
        title={usefulLink.name}
        titleProps={{
          variant: 'h1',
        }}
      />
      <CmtCardContent sx={{ height: '100%', padding: 0 }}>
        <Box display="flex" flexDirection="column" justifyContent="center" sx={{ mt: 2, paddingLeft: 4, paddingRight: 4 }}>
          <Typography fontSize={12} justifyContent="center" sx={{ mb: 1 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: formattedDescription,
              }}
            />
          </Typography>

          {usefulLink.warning && (
            <Typography fontSize={12} justifyContent="center" sx={{ mt: 3 }}>
              <strong>{usefulLink.warning}</strong>
            </Typography>
          )}

          {usefulLink.pdfTitleUrl && usefulLink.pdfUrl && (
            <Typography fontSize={12} justifyContent="center" sx={{ mt: 3 }}>
              {`${t('availableFile')}: `}
              <a href={usefulLink.pdfUrl} target="_blank" rel="noreferrer">
                {usefulLink.pdfTitleUrl}
              </a>
            </Typography>
          )}

          {formattedWebsiteUrl && (
            <Box display="flex" justifyContent="center" sx={{ mt: 3 }}>
              <Button
                href={formattedWebsiteUrl}
                target="_blank"
                rel="noreferrer"
                variant="contained"
                color="secondary"
                size="large"
                disableElevation
                sx={{
                  mt: 4,
                  py: 3,
                  borderRadius: 0,
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#EFBA29',
                    boxShadow: 'none',
                  },
                  '&:active': {
                    boxShadow: 'none',
                  },
                  '&.Mui-focusVisible': {
                    boxShadow: 'none',
                  },
                }}>
                <Typography variant="h1" sx={{ color: '#000', fontSize: { xs: 16, md: 24 }, letterSpacing: '-0.02em' }}>
                  {t('go_to_website')}
                </Typography>
              </Button>
            </Box>
          )}
        </Box>
      </CmtCardContent>
    </CmtCard>
  );
};

export default UsefulLinkCard;
